import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import IconBox from './IconBox'
import Container from '~shared/Container'
import Topic from '~shared/Topic'
import Link from '~shared/Link'
import urls from '~utils/urls'

const UnstyledTechStack = (props) => (
    <Container {...props}>
        <IconBox>
            <IconBox.Body icon="techstack">
                <Topic.Title>
                    Tech stack
                </Topic.Title>
                <Topic.Paragraph>
                    Streamr is a layer zero protocol for real-time data which powers the decentralised Streamr pub/sub network.
                    Above it, blockchains are used for identity, security and payments, currently Ethereum and xDai.
                    On top is the application layer, including the Data Union framework, Marketplace and Core, and all third party applications.
                </Topic.Paragraph>
                <Button
                    tag={Link}
                    kind="primary"
                    size="big"
                    href={urls.docs.index}
                    outline
                    newTab
                    noDecoration
                    noHover
                >
                    Learn more
                </Button>
            </IconBox.Body>
        </IconBox>
    </Container>
)

const TechStack = styled(UnstyledTechStack)`
    padding: 0 1rem;

    ${Topic.Title} {
        margin: 0;
        margin-bottom: 1rem;
        text-align: left;
    }

    ${Topic.Paragraph} {
        margin-bottom: 3rem;
        line-height: 1.75rem;
        font-size: 1rem;
    }

    ${IconBox} + ${IconBox} {
        margin-top: 1.5rem;
    }

    @media (min-width: ${TABLET}px) {
        padding: 0;
        max-width: 44rem;

        ${IconBox} + ${IconBox} {
            margin-top: 3.5rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        max-width: 69rem;

        ${Topic.Paragraph} {
            font-size: 1.125rem;
            line-height: 1.875rem;
        }
    }
`

export default TechStack
